import classNames from 'classnames';
import { type ComponentPropsWithRef, forwardRef } from 'react';

import Button from '../Button';
import Icon from '../Icon';
import Text from '../Text';

type Props = {
  label?: string;
  icon?: string;
  className?: string;
} & ComponentPropsWithRef<typeof Button>;

export const AnimatedButton = forwardRef<HTMLButtonElement, Props>(
  ({ label, icon, className, ...props }, ref) => {
    const commonAnimatedTextStyle =
      'absolute flex flex-row gap-2 h-full w-full items-center justify-center transition-all duration-300';

    return (
      <Button
        ref={ref}
        {...props}
        variant="jbPrimary"
        className={classNames(
          'group/animatedButton relative overflow-hidden',
          className
        )}
      >
        <Text className="flex flex-row items-center justify-center gap-2 opacity-0">
          {label} {!!icon && <Icon icon={icon} />}
        </Text>
        <Text
          className={classNames(
            'top-0 group-hover/animatedButton:-top-full',
            commonAnimatedTextStyle
          )}
        >
          {label} {icon && <Icon icon={icon} className="rotate-[135deg]" />}
        </Text>
        <Text
          className={classNames(
            'top-full group-hover/animatedButton:top-0',
            commonAnimatedTextStyle
          )}
        >
          {label} {icon && <Icon icon={icon} className="rotate-180" />}
        </Text>
      </Button>
    );
  }
);

AnimatedButton.displayName = 'AnimatedButton';
